import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import type { TypographyProps } from '@coursera/cds-core';

export const METADATA_SEPARATOR = ' · ';

interface MetadataTypographyProps {
  /** Whether to display as inline */
  inline?: boolean;
  color?: TypographyProps['color'];
}

/** Render metadata for the course card, inline */
export const MetadataTypography: React.LegacyFunctionComponentWithChildren<MetadataTypographyProps> = ({
  inline,
  color,
  children,
}) => {
  const display = inline ? 'inline' : undefined;
  const typographyColor: TypographyProps['color'] = color ?? 'supportText';
  return (
    <Typography2 component="p" color={typographyColor} display={display} variant="bodySecondary">
      {children}
    </Typography2>
  );
};

const isReactElement = (element: React.ReactElement | false): element is React.ReactElement => element !== false;

/** Concatenates inline elements with the metadata separator */
export const JoinedMetadata = ({ children }: { children: Array<React.ReactElement | false> }) => {
  const renderableChildren: React.ReactElement[] = children
    .filter(isReactElement)
    .filter((element) => Boolean(element.key));
  return (
    <React.Fragment>
      {renderableChildren.map((element, index) => {
        return (
          <React.Fragment key={element.key}>
            {element}
            {index < renderableChildren.length - 1 && METADATA_SEPARATOR}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export const joinMetadataStrings = (collection: string[]): string => collection.join(METADATA_SEPARATOR);
